var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralInformationHospital = function SvgGeneralInformationHospital(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#999",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.985 13.146H12.36V10.5h-.75v2.646H8.985v.75h2.625V16.5h.75v-2.604h2.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 8.25v10.5c0 1.034.841 1.875 1.875 1.875H21.75V8.25H18V3.563H6V8.25zM22.5 21.375H4.125A2.63 2.63 0 0 1 1.5 18.75V7.5h3.75V2.813h13.5V7.5h3.75z"
  }))));
};
export default SvgGeneralInformationHospital;